import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import Invoice from "../components/Invoice";
// import SingleInvoiceDetails from "../components/SingleInvoiceDetails";
import InvoiceDetails from "../containers/InvoiceDetails";
import GenerateInvoice from "../containers/GenerateInvoice";
import ShowPdfInvoice from "../containers/ShowPdfInvoice";

import Moment from "moment";
class BrrokerageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isLoadingBuyerList: true,
      isLoadingSellerList: true,
      paidInvoices: [],
      unPaidInvoices: [],
      sellerCustomersList: [],
      buyerCustomersList: [],
      customersList: [],
      allCustomers: [],
      allDeals: [],
      allInvoices: [],
      appBarName: null,
      sellerCustomerDealsDetails: [],
      buyerCustomerDealsDetails: [],
      allCustomerDeals: [],
      tempAllDeals: [],
      products: [],
      currentUser: [],
      invoicePrintData: [],
      organisations: []
    };
  }

  componentWillMount() {
    this.fetchAllInvoices();
    this.fetchAllDeals();
    this.fetchAllCustomers();
    this.fetchAllCustomerDeals();
    this.fetchProducts();
    this.fetchCurrentUser();
    this.fetchInvoicePrintData();
    this.fetchOrganisations();
  }
  fetchProducts = () => {
    this.props.db
      .collection("products")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const products = [];
        querySnapshot.forEach(doc => {
          const singleProduct = doc.data();
          singleProduct.id = doc.id;
          products.push(singleProduct);
        });
        this.setState({ products, isLoading: false });
      });
  };
  fetchAllDeals = () => {
    this.props.db
      .collection("deals")
      .where("userId", "==", this.props.user.uid)
      .orderBy("date", "desc")
      .onSnapshot(querySnapshot => {
        const allDeals = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleDeal = doc.data();
            singleDeal.id = doc.id;
            allDeals.push(singleDeal);
          }
        });
        this.setState({ allDeals, isLoading: false, tempAllDeals: allDeals });
      });
  };
  fetchCurrentUser = () => {
    this.props.db
      .collection("users")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const currentUser = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleUser = doc.data();
            singleUser.id = doc.id;
            currentUser.push(singleUser);
          }
        });
        this.setState({ currentUser, isLoading: false });
      });
  };
  fetchInvoicePrintData = () => {
    this.props.db
      .collection("invoicePrintData")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const invoicePrintData = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const invData = doc.data();
            invData.id = doc.id;
            invoicePrintData.push(invData);
          }
        });
        this.setState({ invoicePrintData, isLoading: false });
      });
  };
  fetchAllInvoices = () => {
    this.props.db
      .collection("invoices")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        let allInvoices = [];
        const paidInvoices = [];
        const unPaidInvoices = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            if (doc.data().isPaid === true) {
              const singleInvoice = doc.data();
              singleInvoice.id = doc.id;
              paidInvoices.push(singleInvoice);
            } else {
              const singleInvoice = doc.data();
              singleInvoice.id = doc.id;
              unPaidInvoices.push(singleInvoice);
            }
          }
        });
        allInvoices = paidInvoices.concat(unPaidInvoices);
        this.setState({
          paidInvoices,
          unPaidInvoices,
          allInvoices,
          isLoading: false
        });
      });
  };
  fetchAllCustomers = () => {
    this.props.db
      .collection("customers")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const allCustomers = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleCustomer = doc.data();
            singleCustomer.id = doc.id;
            allCustomers.push(singleCustomer);
          }
        });
        this.setState({ allCustomers, isLoading: false });
      });
  };
  fetchAllCustomerDeals = () => {
    this.props.db
      .collection("customerDeals")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const allCustomerDeals = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleCustomer = doc.data();
            singleCustomer.id = doc.id;
            allCustomerDeals.push(singleCustomer);
          }
        });
        this.setState({ allCustomerDeals, isLoading: false });
      });
  };

  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
      });
  };
  updateInvoice = (invoiceId, dealsId, customerId) => {
    this.props.db
      .collection("invoices")
      .doc(invoiceId)
      .update({
        isPaid: true
      });
    dealsId.map(dealsId => {
      return this.props.db
        .collection("customerDeals")
        .doc(customerId + "_" + dealsId)
        .update({ isInvoicePaid: true });
    });
  };
  applyDateFilter = selectedMonth => {
    let tAllDeals = [];
    if (selectedMonth !== "All") {
      if (this.state.tempAllDeals.length > 0) {
        tAllDeals = this.state.tempAllDeals.filter(
          data => Moment(data.createdAt.toDate()).format("MM") === selectedMonth
        );
        this.setState({ allDeals: tAllDeals }, () => {
          console.log(1);
        });
      } else {
        console.log("Array is empty........");
      }
    } else {
      this.setState({ allDeals: this.state.tempAllDeals }, () => {
        console.log(1);
      });
    }
  };
  render() {
    const {
      isLoading,
      allDeals,
      allCustomers,
      paidInvoices,
      unPaidInvoices,
      allCustomerDeals,
      products,
      currentUser,
      invoicePrintData,
      organisations
    } = this.state;
    const { user } = this.props;
    return (
      <div>
        <Route
          exact
          path="/invoice"
          render={props => (
            <Invoice
              {...props}
              allDeals={allDeals}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
              paidInvoices={paidInvoices}
              unPaidInvoices={unPaidInvoices}
              allCustomers={allCustomers}
              allCustomerDeals={allCustomerDeals}
              applyDateFilter={this.applyDateFilter}
            />
          )}
        />
        <Route
          exact
          path="/invoice/:customerId/InvoiceDetail"
          render={props => (
            <InvoiceDetails
              {...props}
              products={products}
              isLoading={isLoading}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
              paidInvoices={paidInvoices}
              unPaidInvoices={unPaidInvoices}
              allDeals={allDeals}
              allCustomers={allCustomers}
              allCustomerDeals={allCustomerDeals}
              user={user}
              currentUser={currentUser.find(cUser => cUser.id === user.uid)}
              invoicePrintData={invoicePrintData}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
        <Route
          exact
          path="/invoice/:customerId/generateInvoice"
          render={props => (
            <GenerateInvoice
              {...props}
              allDeals={allDeals}
              unPaidInvoices={unPaidInvoices}
              allCustomers={allCustomers}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
              allCustomerDeals={allCustomerDeals}
              user={user}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        />
        <Route
          exact
          path="/invoice/:customerId/showPdfInvoice/:invoiceId"
          render={props => (
            <ShowPdfInvoice
              {...props}
              products={products}
              isLoading={isLoading}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
              paidInvoices={paidInvoices}
              unPaidInvoices={unPaidInvoices}
              allDeals={allDeals}
              allCustomers={allCustomers}
              allCustomerDeals={allCustomerDeals}
              user={user}
              currentUser={currentUser.find(cUser => cUser.id === user.uid)}
              invoicePrintData={invoicePrintData}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(BrrokerageContainer)));
